"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

var _useUtils = require("../../_helpers/use-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./Delay.css");

var _styles = {
  "container": "Delay__container___tWaAP",
  "fadeIn": "Delay__fadeIn___1S3Kp"
};

const styles = _bind.default.bind(_styles);

const Delay = (0, _mobxReact.observer)(({
  children,
  waitBeforeShow = 500
}) => {
  const [isShown, setIsShown] = (0, _react.useState)(false);
  const composed_classname = (0, _bind.default)(styles('container'));
  (0, _useUtils.useDelayedEffectOnce)(waitBeforeShow, () => setIsShown(true));
  return isShown ? _react.default.createElement("div", {
    className: composed_classname
  }, children) : _react.default.createElement(_react.default.Fragment, null);
});
var _default = Delay;
exports.default = _default;